import { bff, createBFFHandlers } from '~/framework/bff';
import { z } from 'zod';
import { getServerSideMonolithClient } from '~/framework';
import { getWikis, getSuggestions, WikiPage } from '~/monolith-api';

export type { WikiPage };

const optionsSchema = z.object({
   query: z.string().optional(),
   modifiedSince: z.number().optional(),
   offset: z.number().optional(),
   limit: z.number().optional(),
   langid: z.number().optional(),
});

export default createBFFHandlers({
   post: async (req, res) => {
      const monolithClient = getServerSideMonolithClient(req);
      const { query, modifiedSince, offset, limit, langid } = optionsSchema.parse(req.body);

      let results: WikiPage[];

      if (query && query.length > 3) {
         const suggestions = await getSuggestions<'wiki'>(query, {
            doctypes: 'wiki',
            includeUnreleased: true,
            showAllLanguages: true,
            apiClient: monolithClient,
         });

         // Currently, there is no way to limit results via query params.
         //    Limiting results here for consistency.
         results = suggestions.slice(0, limit);
      } else {
         results = await getWikis({
            modifiedSince: modifiedSince,
            limit: limit,
            offset: offset,
            langid: langid,
            apiClient: monolithClient,
         });
      }

      res.status(200).json(results);
   },
});

export const getWikisFromClient = (options: GetWikisOptions): Promise<GetWikisResult> => {
   return bff()
      .post('/wikis/getWikis', options)
      .then(response => response.data);
};

export type GetWikisOptions = z.infer<typeof optionsSchema>;

export type GetWikisResult = WikiPage[];
